import {
    apiRequest,
    tukinList,
    tukinActive,
    tukinInactive
} from "../../../../../services/adapters/kepegawaian/honorariumService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", tukinList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    // fetchInactive = async (query) => {
    //     return await apiRequest("post", tukinInactive, {
    //         body: query
    //     }, true)
    // }

    // fetchActive = async (query) => {
    //     return await apiRequest("post", tukinActive, {
    //         body: query
    //     }, true)
    // }
}

export default DataTableRepository